import { ApprovedUserStatement, formatStatementCategory } from "../approvedUsersUtils";

const ResearchUseStatementCell = (params: any) => {
    const statements: ApprovedUserStatement[] = params.data?.researchUseStatements ?? [];

    if (statements.length === 0) return null;

    if (statements.length === 1) {
        return <span>{statements[0].statement}</span>;
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', padding: '8px 0' }}>
            {statements.map(({ category, statement }, index) => (
                <p key={`${category}-${index}`} style={{ margin: 0 }}>
                    <strong style={{ fontWeight: 700 }}>{formatStatementCategory(category)}:</strong> {statement}
                </p>
            ))}
        </div>
    );
};

export default ResearchUseStatementCell;
